import { wneMetricConfigUnification } from '@gonfalon/dogfood-flags/dogfood-flags';
import { isLDHosted } from '@gonfalon/metrics/isLDHosted';

export function supportsValueColumn(dataSourceKey?: string): boolean {
  return wneMetricConfigUnification() && typeof dataSourceKey === 'string' && !isLDHosted(dataSourceKey);
}
